import gql from 'graphql-tag'

export const insertRole = (role, commercial_base) => {
	return {
		mutation: gql`
			mutation insertSingleRole($role: roles_insert_input!) {
				insert_roles_one(object: $role) {
					id
				}
			}
		`,
		variables: {
			role
		}
	}
}

// TODO: fix
// commercial_base: comercial_base.map(item => ({
// 	role_id,
// 	commercial_base_id: item.id
// }))
